module.exports = __webpack_public_path__ + "img/11.84aa61fd.png";